// extracted by mini-css-extract-plugin
export default {"comment":"CommunityComments_comment__Fk84Z","contents":"CommunityComments_contents__aOw-v","input":"CommunityComments_input__HC8OS"};